import { getDateComparator } from '@/utilities/dates'
import { getFormattedUTCDateTime } from '@/utilities/dates'

const stringTextMatcher = ({ value, filterText }) => {
  const filterTextLowerCase = filterText.toLowerCase()
  const valueLowerCase = value.toString().toLowerCase()

  const array = filterTextLowerCase.split(',')
  return array.includes(valueLowerCase)
}

const arrayTextMatcher = ({ value, filterText }) => {
  const filterTextLowerCase = filterText.toLowerCase()
  const valueLowerCase = value.toLowerCase().trim()

  return filterTextLowerCase.includes(valueLowerCase)
}

const dateStringMatcher = ({ value, filterText }) => {
  const filters = filterText.split(',')
  if (filters.length === 3) {
    const cellDate = new Date(value)
    const pickerValue = filters[0]
    const startDate = new Date(filters[1])
    const endDate = new Date(filters[2])
    return getDateComparator(pickerValue, startDate, endDate, cellDate)
  }
  return 1
}

const UTCDateStringMatcher = ({ value, filterText }) => {
  const filters = filterText.split(',')
  if (filters.length === 3) {
    const cellDate = getFormattedUTCDateTime(value)
    const pickerValue = filters[0]
    const startDate = getFormattedUTCDateTime(filters[1])
    const endDate = getFormattedUTCDateTime(filters[2])
    return getDateComparator(pickerValue, startDate, endDate, cellDate)
  }
  return 1
}

const exactStringMatcher = ({ value, filterText }) => {
  const filterTextLowerCase = filterText.toLowerCase()
  const valueLowerCase = value.toString().toLowerCase()
  return valueLowerCase.indexOf(filterTextLowerCase) > -1
}

const exactEqualStringMatcher = ({ value, filterText }) => {
  const filterTextLowerCase = filterText.toLowerCase()
  const valueLowerCase = value.toString().toLowerCase()
  return valueLowerCase.indexOf(filterTextLowerCase) >= 0
}

const exactFilterToValueMatcher = ({ value, filterText }) => {
  const filterTextLowerCase = filterText.toLowerCase()
  const valueLowerCase = value.toString().toLowerCase()
  return filterTextLowerCase.indexOf(valueLowerCase) > -1
}

const exactUnitFilterValueMatcher = ({ value, filterText }) => {
  const filterTextLowerCase = filterText?.toLowerCase()
  const valueLowerCase = value?.toString().toLowerCase()
  const array = filterText ? filterTextLowerCase?.split(',') : []
  return array.length ? array.includes(valueLowerCase) : true
}
export {
  stringTextMatcher,
  arrayTextMatcher,
  dateStringMatcher,
  UTCDateStringMatcher,
  exactStringMatcher,
  exactEqualStringMatcher,
  exactFilterToValueMatcher,
  exactUnitFilterValueMatcher,
}
